export default __webpack_public_path__ + "e6a4b8746b031732d78cdae30b2834b5.svg";